import React from 'react';

const variantPrimary = {
  padding: '12px 20px',
  borderRadius: 8,
  border: '1px solid rgba(0, 212, 255, 0.5)',
  background: 'linear-gradient(135deg, #B026FF 0%, #0066FF 100%)',
  color: '#fff',
  cursor: 'pointer',
  fontWeight: 600,
  fontSize: 16,
};

const VARIANTS = {
  primary: variantPrimary,
};

/**
 * Botão primário do dashboard (gradiente). Use `fullWidth` no login e formulários de largura total.
 */
export default function Button({
  variant = 'primary',
  fullWidth = false,
  type = 'button',
  style,
  className,
  disabled,
  children,
  ...rest
}) {
  const base = VARIANTS[variant] || VARIANTS.primary;
  const merged = {
    ...base,
    ...(fullWidth ? { width: '100%', boxSizing: 'border-box' } : {}),
    ...(disabled ? { opacity: 0.65, cursor: 'not-allowed' } : {}),
    ...style,
  };

  return (
    <button type={type} className={className} style={merged} disabled={disabled} {...rest}>
      {children}
    </button>
  );
}
